import axios from 'axios';
import {
    signupUrl,
    loginUrl,
    forgotPasswordUrl,
    setNewPasswordUrl,
    addSpotUrl,
    getOwnerSpotsUrl,
    updateSpotUrl,
    getMenuUrl,
    getBankListUrl,
    withdrawFundsUrl,
    confirmWithdrawalUrl,
    getTransactionUrl,
    getBankAccountNameUrl,
    getSpotStaffUrl,
    raverOrderUrl,
    raverTabUrl,
    getCategoriesUrl,
    getTabHistoryUrl,
} from './urls';
import router from '../router';
import { getFromStore, removeFromStore } from 'src/Utils/storage-helpers';

export const request = async (url, action, data = null, extraHeaders) => {
    const token = await getFromStore('accessToken');
    const config = {
        Accept: '*/*',
        ...(token && { Authorization: `Bearer ${token}` }),
        ...(extraHeaders && extraHeaders),
    };

    try {
        const response = await axios({
            method: action,
            url,
            data,
            headers: config,
        });
        return response;
    } catch (error) {
        if (error.response.status === 401 && !!token) {
            removeFromStore("accessToken");
            return router.navigate("/login");
        }
        if (error.response.status === 500) {
            error.response["data"] = {
                detail: "Server Error. Please try again in a few minute or reach out to info@jamlyf.com."
            }
            return error;
        } else if (error.response.statusText === "Unauthorized") {
            error.response["data"] = {
                detail: "Login and ensure that the email or password provider are correct."
            }
            return error;
        } else {
            return error;
        }
    }
};

export const requestUserSignup = async data => {
    return await request(signupUrl(), 'post', data);
};

export const userLogin = async data => {
    return await request(loginUrl(), 'post', data);
};

export const forgotPassword = async data => {
    return await request(forgotPasswordUrl(), 'post', data);
};

export const setNewPassword = async data => {
    return await request(setNewPasswordUrl(), 'put', data);
};

export const addSpot = async data => {
    return await request(addSpotUrl(), 'post', data);
};

export const getOwnerSpots = async (ownerId, spotId = null, search = null) => {
    return await request(getOwnerSpotsUrl(ownerId, spotId, search), 'get');
};

export const updateSpot = async (args) => {
    const { id: spotId, data} = args;
    return await request(updateSpotUrl(spotId), 'put', data);
};

export const getSpotStaff = async (queryParams) => {
    const {id, ...urlParams} = queryParams;
    return await request(getSpotStaffUrl(id, urlParams), 'get');
};

export const getSpotMenu = async (queryParams) => {
    return await request(getMenuUrl(queryParams), 'get');
};

export const addSpotMenu = async ({ data }) => {
    return await request(getMenuUrl(), 'post', data);
};

export const getMenu = async ({ id }) => {
    return await request(getMenuUrl({ id }), 'get');
};

export const updateMenu = async ({ id, data }) => {
    return await request(getMenuUrl({ id }), 'put', data);
}

export const deleteMenu = async({ id }) => {
    return await request(getMenuUrl({ id }), 'delete');
}

export const getBankList = async () => {
    return await request(getBankListUrl(), 'get');
};

export const getOtp = async (amount, spot) => {
    return await request(withdrawFundsUrl(amount, spot), 'get');
};

export const withdraw = async data => {
    return await request(confirmWithdrawalUrl(), 'post', data);
};

export const getTransaction = async (queryParams) => {
    return await request(getTransactionUrl(queryParams), 'get');
};

export const getBankAccountName = async (params) => {
    return await request(getBankAccountNameUrl(params), 'get');
};

export const createRaverOrder = async (data) => {
    return await request(raverOrderUrl(), 'post', data);
};

export const updateRaverOrder = async (params, data, headers) => {
    return await request(raverOrderUrl(params), 'put', data, headers);
};

export const deleteRaverOrder = async (params) => {
    return await request(raverOrderUrl(params), 'delete');
};

export const getRaverTab = async (params, headers) => {
    return await request(raverTabUrl(params), 'get', null, headers);
};

export const updateRaverTab = async (params, data) => {
    return await request(raverTabUrl(params), 'patch', data);
};

export const getAllCategories = async () => {
    return await request(getCategoriesUrl(), 'get');
};

export const getSpotCategories = async (spotId) => {
    return await request(getCategoriesUrl(spotId), 'get');
};

export const getTabHistory = async (params) => {
  return await request(getTabHistoryUrl(params), "get");
};
